<template>
  <tux-message
    :button-text="messagePageContent.buttonText"
    :secondary-button-text="messagePageContent.secondaryButtonText"
    :header="$t(messagePageContent.header, { countryName })"
    :icon-class="messagePageContent.iconClass"
    :message="messagePageContent.message"
    :name="messagePageContent.errorId"
    :session-id-text="sessionIdText"
    @cta-click="handleCtaClick"
    @secondary-cta-click="handleSecondaryCtaClick">
  </tux-message>
</template>

<script>
import { TuxMessage } from '@mc-alberta/tuxedo'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ROUTES } from '@/constants'
import * as types from '@/store/mutation-types'
import { getTraceId } from '@/utils/traceId'

export default {
  name: ROUTES.ERROR,
  components: { TuxMessage },
  computed: {
    ...mapState({
      currentCountry: (state) => state.user.consumer.countryCode,
      messagePageContent: (state) => state.messagePageContent,
      postLoginPath: (state) => state.postLoginPath
    }),
    isUnavailableCountryPage() {
      return this.$route.name === ROUTES.UNAVAILABLE
    },
    sessionIdText() {
      if (this.isUnavailableCountryPage) {
        return null
      }

      return getTraceId()
    },
    countryName() {
      return this.$i18nData.getCountryName(this.currentCountry)
    }
  },
  watch: {
    /**
     * Redirect if country is supported
     */
    currentCountry: {
      immediate: true,
      handler(country) {
        if (this.isUnavailableCountryPage && this.$i18nData.isCountryLive(country)) {
          this.$router.replace({ name: ROUTES.ENTRY })
        }
      }
    }
  },
  beforeDestroy() {
    this.resetMessagePageContent()

    if (this.postLoginPath) {
      this.setPostLoginPath(null)
    }
  },
  methods: {
    ...mapActions(['resetMessagePageContent']),
    ...mapMutations({
      setPostLoginPath: types.SET_POST_LOGIN_PATH
    }),
    handleCtaClick() {
      this.$analytics.track(this.$EVENTS.OK_BUTTON)

      if (Object.values(ROUTES).includes(this.messagePageContent.buttonTarget)) {
        return this.$router.replace({
          name: this.messagePageContent.buttonTarget
        })
      }
      window.location.replace(this.messagePageContent.buttonTarget)
    },
    handleSecondaryCtaClick() {
      return this.$router.replace({
        name: this.messagePageContent.secondaryButtonTarget
      })
    }
  }
}
</script>
